/* eslint-disable import/no-anonymous-default-export */
import { useDispatch, useSelector } from "react-redux";
import Page from "../../components/layout/Page";
import SearchCard from "./Components/SearchCard";
import "./index.scss";
import SearchResults from "./Components/SearchResults";
import { useEffect, useState } from "react";
import qs from 'query-string'
import { postRequest } from "../../services/requestService";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Stats from "../SavedJobs/Components/Stats";
import { Spin } from "antd";
import Button from "../../components/forms/Button";
import { FaPlus } from '@react-icons/all-files/fa/FaPlus'
import { setModalState } from "../../store/reducers/Modal/actions";
import { hasCredits } from "../../services/billingService";
import { reportEvent, trackServerEvent } from "../../services/analyticsService";
import { FaLock } from "@react-icons/all-files/fa/FaLock";
export default props => {
    const location = useLocation();
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const [jobs, setJobs] = useState([])
    useEffect(() => {
        fetchJobs()
    }, [location.search, userDetails])

    const fetchJobs = async () => {
        try {
            const queryObj = qs.parse(window.location.search);
            setLoading(true)
            queryObj.jobSearchQueries = (queryObj.jobSearchQueries || "").split(',').map(a => a.trim())
            const res = await postRequest('listing/list', queryObj)
            setJobs(res.data.jobs)
        }
        catch (e) {

        }
        setLoading(false)
    }
    return (
        <Page className="dashboard">
            <Stats />
            <div className="dashboard-inner">
                <div className="dashboard-header">
                    <div>
                        <h1>AI Job Matching</h1>
                    </div>
                    <Button onClick={() => {
                        if (!hasCredits(userDetails)) {
                            trackServerEvent('import-job-click-show-upgrade-search')
                            reportEvent('upgrade_modal', 'open', { location: 'savedJobs' })
                            dispatch(setModalState('isUpgradeModalOpen', true))
                        }
                        else {
                            trackServerEvent('import-job-click-show-import-search')
                            reportEvent('import_job_modal', 'open', { location: 'savedJobs' })
                            dispatch(setModalState('isImportJobModalOpen', true))
                        }

                    }}>
                        {hasCredits(userDetails) ? <FaPlus /> : <FaLock />}
                        Import Job</Button>
                </div>
                <SearchCard userDetails={userDetails} loading={loading} />
                {loading && <Spin />}
                <SearchResults setLoading={setLoading} jobs={jobs} setJobs={setJobs} />
            </div>

        </Page>
    )
}